import { User } from "@auth0/auth0-react";

export function isYotpo(user: User | undefined): boolean {
  if (user == null || user.owner == null) {
    return false;
  }

  return ["yotpo"].includes(user.owner);
}
